import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-374cade6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<h1 class=\"p-card p-shadow-2 p-text-bold p-p-3 p-text-center p-text-uppercase\" data-v-374cade6> Plateforme de caisse </h1><div class=\"p-grid p-mt-4\" data-v-374cade6><div class=\"p-col-12 p-md-6 p-p-3\" data-v-374cade6><h3 class=\"p-mt-6\" data-v-374cade6>Manuel utilisateur</h3><p style=\"font-size:1.4em;line-height:1.5em;\" data-v-374cade6> La plateforme Africapos est l&#39;outil de travail du commerçant. Elle fournit divers fonctionnalités nécessaires pour gérer ses activités en ligne. Elle inclut les gestions d&#39;entrée et sortie de stock, suivi des dépenses, point de vente et génereration des rapports journaliers. En complément de ces différentes fonctionnalités, le propriétaire d&#39;une activité a la possibilité d&#39;avoir des collaborateurs dont chacun un rôle approprié. Elle expose les menus principaux qui nous permettent de nous positionner. L&#39;interface est très intuitive et facile à utiliser même si vous êtes un débutant aux logiciels informatiques. </p></div><div class=\"p-col-12 p-md-6\" data-v-374cade6><div style=\"\" class=\"p-shadow-4 p-card image\" data-v-374cade6></div></div></div><h5 data-v-374cade6>Indication générale de l&#39;utilisation</h5>", 3)
const _hoisted_4 = { class: "p-d-flex p-justify-center p-pt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_Timeline, {
      value: _ctx.steps,
      layout: "horizontal",
      align: "alternate"
    }, {
      marker: _withCtx((slotProps) => [
        _createElementVNode("span", {
          class: "custom-marker p-shadow-2",
          style: _normalizeStyle({ backgroundColor: slotProps.item.color })
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.featureIcons[slotProps.item.icon])
          }, null, 2)
        ], 4)
      ]),
      content: _withCtx((slotProps) => [
        _createTextVNode(_toDisplayString(slotProps.item.label), 1)
      ]),
      opposite: _withCtx(() => [
        _createTextVNode("   ")
      ]),
      _: 1
    }, 8, ["value"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        style: {"width":"50%"},
        label: "En savoir plus",
        class: "p-button-warning p-shadow-4 p-py-3 p-button-rounded",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/documentation/account')))
      })
    ])
  ], 64))
}